import { Box, DateInput, Text, ResponsiveContext } from 'grommet';
import React from 'react';
import { CLIENT_TYPE, PRODUCT } from '../../../services/types';
import CheckBoxCards from '../../elements/checkbox_card';
import locataire from '../../../images/locataire.png'
import proprietaire from '../../../images/proprietaire.png'
import oui from '../../../images/oui.png'
import non from '../../../images/non.png'
import ClickableCards from '../../elements/clickable_card';
import CustomInput from '../../elements/custom_input';
import AddressInfo from '../../elements/address';
import translate from '../../../i18n/translate';
import { getSimpleDateFR, isMH, isPhone, isSmallDevis } from '../../../services/utils';
import { getBounds } from '../../../services/services';
import LineBox from '../../responsive/line_container';

const pnoMaxRooms = [1, 2, 3, 4, 5, 6, 7, 8, 9]
const mhMaxRooms = [1, 2, 3, 4, 5, 6]

const isMHTEMPO = product => product === PRODUCT.MH_TEMPO;

const Characteristic = ({ devis, product, onDevisChange }) => {
    return (
        <ResponsiveContext.Consumer>
            {size => (
                <Box align='center' justify='center' gap='small' pad={'small'}>
                    <Box width={'large'} gap='medium'>
                        {isMH(product) && <LineBox
                            size={size}
                            leftText={translate('vous_etes') + ' ?'}
                            rightChild={
                                <CheckBoxCards
                                    cards={[
                                        {
                                            title: translate('proprietaire'),
                                            photo: proprietaire,
                                            size: 'small',
                                            checked: devis.clientType === CLIENT_TYPE.proprietaire,
                                            onChange: () => {
                                                if (isMHTEMPO(product)) return;
                                                onDevisChange('clientType', CLIENT_TYPE.proprietaire)
                                            }
                                        },
                                        {
                                            title: translate('locataire'),
                                            photo: locataire,
                                            size: 'small',
                                            checked: devis.clientType === CLIENT_TYPE.locataire,
                                            onChange: () => onDevisChange('clientType', CLIENT_TYPE.locataire)
                                        },
                                    ]}
                                />
                            }
                        />
                        }
                        <LineBox
                            size={size}
                            leftText={translate('nombre_piece')}
                            rightChild={
                                <ClickableCards
                                    size={size}
                                    cards={(isMH(product) ? mhMaxRooms : pnoMaxRooms).map(idx => ({
                                        title: ' ' + idx + ' ',
                                        selected: devis.totalRooms === idx,
                                        onClick: () => onDevisChange('totalRooms', idx)
                                    }))}
                                />
                            }
                        />
                        <LineBox
                            size={size}
                            leftText={translate('surface')}
                            rightChild={
                                <Box width={ isPhone(size) ? 'full' : 'small'}>
                                    <CustomInput
                                        placeholder={'m2'}
                                        value={devis.surface}
                                        onChange={event => onDevisChange('surface', event.target.value)}
                                    />
                                </Box>
                            }
                        />
                        <LineBox
                            size={size}
                            leftText={translate('resiliation')}
                            rightChild={
                                <CheckBoxCards
                                    cards={[
                                        {
                                            title: translate('oui'),
                                            photo: oui,
                                            size: isSmallDevis(size) ? 'xxsmall' : 'xsmall',
                                            checked: devis.resilierContrat === true,
                                            onChange: () => onDevisChange('resilierContrat', true)
                                        },
                                        {
                                            title: translate('non'),
                                            photo: non,
                                            size: isSmallDevis(size) ? 'xxsmall' : 'xsmall',
                                            checked: devis.resilierContrat === false,
                                            onChange: () => onDevisChange('resilierContrat', false)
                                        },
                                    ]}
                                />
                            }
                        />
                        <AddressInfo
                            devis={devis}
                            onDevisChange={onDevisChange}
                            placeField={{
                                address: 'address',
                                zip: 'zip',
                                city: 'city'
                            }}
                            title={translate('address_bien')}
                        />
                        {isMHTEMPO(product) &&
                            <Box width={'large'} gap='medium'>
                                <Text>
                                    Indiquer les dates de <b>début</b> de <b>fin</b> de votre location :
                                </Text>
                                <Box direction={isPhone(size) ? 'column' : 'row'} gap='medium' width={'large'} align="center">
                                    <Box direction='row' align="center" justify='between' style={{ width: isPhone(size) ? '100%' : '50%' }} gap="small">
                                        <Text>De: </Text>
                                        <CustomInput value={devis.effectiveDate ? getSimpleDateFR(devis.effectiveDate) : ''} />
                                        <DateInput
                                            calendarProps={{ bounds: getBounds(devis), locale: 'fr-FR' }}
                                            value={devis.effectiveDate}
                                            onChange={event => onDevisChange('effectiveDate', new Date(event.value))}
                                        />
                                    </Box>
                                    <Box direction='row' align="center" style={{ width: isPhone(size) ? '100%' : '50%' }} gap="small">
                                        <Text>À: </Text>
                                        <CustomInput value={devis.date_fin ? getSimpleDateFR(devis.date_fin) : ''} />
                                        <DateInput
                                            calendarProps={{ bounds: getBounds(devis), locale: 'fr-FR' }}
                                            value={devis.date_fin}
                                            onChange={event => onDevisChange('date_fin', new Date(event.value))}
                                        />
                                    </Box>
                                </Box>
                            </Box>

                        }
                    </Box>
                </Box>
            )}
        </ResponsiveContext.Consumer>
    )
}


export default Characteristic;